module.exports = __webpack_public_path__ + "img/connector-types-mobile-fr.9eaad826.webp";